import axios from "axios";
const jsonConfig = require("../../Config.json");

const getAllInvitedCandidateResponse = async () => {
    let allResponse = {}
    try {
        const Response = await  axios.get(
            jsonConfig.apiUrl + "GetAllInvitedCandidate", 
            {
                headers: {
                    "x-functions-key": jsonConfig.key,
                },
            }
        );
        
        allResponse = Response;
        return Promise.resolve(allResponse)
    }
    catch (error) {
        return Promise.reject(error)
    }
}

export default getAllInvitedCandidateResponse;